import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { DatiPersonaFisica } from '../../models/portale/dati-persona-fisica';

@Component({
	selector: 'lib-dati-anagrafici',
	templateUrl: './dati-anagrafici.component.html',
	styleUrls: ['./dati-anagrafici.component.css']
})
export class DatiAnagraficiComponent implements OnInit, OnChanges {

	form: FormGroup;

	@Input() datiPersonaFisica$: Observable<DatiPersonaFisica>;


	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {}

	ngOnInit(): void {
		this.form = new FormGroup({});
	}

}
